import PropTypes from 'prop-types';
import React from 'react';
import FormGroup from 'react-bootstrap/FormGroup';
import InputGroup from 'react-bootstrap/InputGroup';

import './boolean-box.scss';

import FieldError from '../field-error';

export const BooleanBox = (props) => {
    const errorId = props.field ? `${props.field}-error` : null;

    return (
        <FormGroup className="boolean-box" controlId={props.id}>
            <InputGroup.Checkbox
                id={props.field}
                name={props.field}
                checked={!!props.checked}
                onChange={props.onChange}
                {...(props.error && { className: 'is-invalid', 'aria-invalid': 'true', 'aria-describedby': errorId })}
            />
            <label className="input-group-text" htmlFor={props.field}>
                {props.label}
            </label>
            <FieldError id={errorId} error={props.error} />
        </FormGroup>
    );
};

BooleanBox.propTypes = {
    id: PropTypes.string,
    field: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.string,
    // The component coerces with `checked={!!props.checked}`, so it intentionally
    // accepts truthy/falsy numeric flags (e.g. 0/1) as well as booleans.
    checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    onChange: PropTypes.func,
};
